import { Pipe, PipeTransform } from "@angular/core";
import dayjs from "@webapp/shared/libs/dayjs";

@Pipe({ name: "pagerDate" })
export class CadencePagerDatePipe implements PipeTransform {
  public transform<InputType>(date: InputType): string | InputType {
    if (typeof date === "string" || date instanceof String) {
      return dayjs(date.toString()).format("MMM D");
    } else {
      return date;
    }
  }
}
